import { useContext } from 'react';
import {
    ACTIONS,
    Private_Routes,
    validationUsualSundays,
} from '../../../../constants';
import { ControllerOpenModals } from '../../../../models';
import {
    getChildNodes,
    getDatesBetweenDates,
    getInterruptionsListBetweenDates,
    getWorkshiftScheduling,
} from '../../../../utils';
import { getActionService } from '../../../../utils/getActionService';
import { AppContext } from '../../../context';
import {
    controllerAdditionalTimeModal,
    controllerAidTypesModal,
    controllerBusinessUnitsModal,
    controllerCopyWorkshiftSchedulings,
    controllerCostCenterModal,
    controllerDisassociatedBusinessUnitsModal,
    controllerDisassociatedCostCentersModal,
    controllerExceptionalWorkshiftModal,
    controllerIDeleteWorkshiftModal,
    controllerInterruptionModal,
    controllerModifyAdditionalTimeModal,
    controllerModifyInterruptionModal,
    controllerOpenWorkshiftModal,
    controllerPasteWorkshiftSchedulings,
    controllerPrintInterruptionsModal,
} from '../../../controller-open-modals';
import { controllerInconsistenciesModal } from '../../../controller-open-modals/controllerInconsistenciesModal';
import { controllerValidationWorkshiftsSundaysUsualsModal } from '../../../controller-open-modals/controllerValidationWorkshiftsSundaysUsualsModal';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useLiquidatedOvertimeHours } from '../../../../pages/payroll-novelty/hooks/useLiquidatedOvertimeHours';
import { RequestLiquidatedOvertimeHourRequest } from '../../../../pages/payroll-novelty/models/requests';

const ToolsBar = ({
    startDate,
    endDate,
    treeEmployees,
    openAdditionalHours,
    openDeleteWorkshiftModal,
    openInterruptionModal,
    openUpdateAndDeleteAdditionalHoursModal,
    openUpdateAndDeleteInterruptionsModal,
    openWorkshiftModal,
    openCostCenterModal,
    openBusinessUnitsModal,
    openAidTypesModal,
    openDisassociatedBusinessUnitsModal,
    openDisassociatedCostCenterModal,
    openCopyWorkshiftsSchedulings,
    openSavePasteWorkshiftsSchedulings,
    saveExceptionalWorkshiftsScheduling,
    handlerValidateWorkshiftsExceptionals,
    handlerValidateNovelties,
    modifyAssociateTimeAttendanceEvents: modifyAssociateMarkings,
    openAssociateTimeAttendanceEvents: openAssociateMarkings,
    saveWorkshiftsSundaysUsuals,
}: ControllerOpenModals) => {
    const {
        grid,
        langResources,
        workshiftShedulingList,
        interruptionList,
        userInfo,
        workshiftsSchedulingsCopied,
        downloadReport,
        inconsistenciesValidation,
        handlerOpenInconsistenciesModal,
        handlerValidationWorkshiftsSundaysUsuals,
    } = useContext(AppContext);

    const navigate = useNavigate();

    const { overtimeLiquidation, isLoading } = useLiquidatedOvertimeHours();

    const openWorkshift = () => {
        controllerOpenWorkshiftModal({
            grid,
            treeEmployees,
            startDate,
            endDate,
            openWorkshiftModal,
        });
    };

    const openDeleteWorkshift = () => {
        controllerIDeleteWorkshiftModal({
            grid,
            treeEmployees,
            startDate,
            endDate,
            workshiftShedulingList,
            openDeleteWorkshiftModal,
            getWorkshiftScheduling,
        });
    };

    const openExceptionalWorkshift = () => {
        controllerExceptionalWorkshiftModal({
            grid,
            treeEmployees,
            startDate,
            endDate,
            workshiftShedulingList,
            getWorkshiftScheduling,
            saveExceptionalWorkshiftsScheduling,
        });
    };

    const openInterruption = () => {
        controllerInterruptionModal({
            grid,
            treeEmployees,
            startDate,
            endDate,
            openInterruptionModal,
            getWorkshiftScheduling,
            workshiftShedulingList,
        });
    };

    const openUpdateInterruptions = () => {
        controllerModifyInterruptionModal({
            grid,
            treeEmployees,
            startDate,
            endDate,
            getInterruptionsList: getInterruptionsListBetweenDates,
            openUpdateAndDeleteInterruptionsModal,
            interruptionList,
        });
    };

    const openAdditionalsHours = () => {
        controllerAdditionalTimeModal({
            grid,
            treeEmployees,
            startDate,
            endDate,
            openAdditionalHours,
            getWorkshiftScheduling,
            workshiftShedulingList,
        });
    };

    const openUpdateAdditionalHours = () => {
        controllerModifyAdditionalTimeModal({
            grid,
            treeEmployees,
            startDate,
            endDate,
            workshiftShedulingList,
            getWorkshiftScheduling,
            openUpdateAndDeleteAdditionalHoursModal,
        });
    };

    const downloadInterrptionFormat = () => {
        controllerPrintInterruptionsModal({
            grid,
            treeEmployees,
            startDate,
            endDate,
            langResources,
            downloadReport,
            getInterruptionsList: getInterruptionsListBetweenDates,
            interruptionList,
        });
    };

    const openCostCenter = () => {
        controllerCostCenterModal({
            grid,
            treeEmployees,
            startDate,
            endDate,
            openCostCenterModal,
            getInterruptionsList: getInterruptionsListBetweenDates,
            getWorkshiftScheduling,
            interruptionList,
            workshiftShedulingList,
        });
    };

    const openBusinessUnits = () => {
        controllerBusinessUnitsModal({
            grid,
            treeEmployees,
            startDate,
            endDate,
            openBusinessUnitsModal,
            getInterruptionsList: getInterruptionsListBetweenDates,
            getWorkshiftScheduling,
            interruptionList,
            workshiftShedulingList,
        });
    };

    const openAidType = () => {
        controllerAidTypesModal({
            grid,
            startDate,
            endDate,
            treeEmployees,
            openAidTypesModal,
        });
    };

    const openDisassociatedCostCenter = () => {
        controllerDisassociatedCostCentersModal({
            grid,
            treeEmployees,
            startDate,
            endDate,
            openDisassociatedCostCenterModal,
            getInterruptionsList: getInterruptionsListBetweenDates,
            getWorkshiftScheduling,
            interruptionList,
            workshiftShedulingList,
        });
    };

    const openDisassociatedBusinessUnits = () => {
        controllerDisassociatedBusinessUnitsModal({
            grid,
            treeEmployees,
            startDate,
            endDate,
            openDisassociatedBusinessUnitsModal,
            getInterruptionsList: getInterruptionsListBetweenDates,
            getWorkshiftScheduling,
            interruptionList,
            workshiftShedulingList,
        });
    };

    const openCopyWorkshiftsScheduling = () => {
        controllerCopyWorkshiftSchedulings({
            grid,
            treeEmployees,
            startDate,
            endDate,
            workshiftShedulingList,
            getWorkshiftScheduling,
            openCopyWorkshiftsSchedulings,
        });
    };

    const openPasteWorkshiftsScheduling = () => {
        controllerPasteWorkshiftSchedulings({
            grid,
            treeEmployees,
            startDate,
            endDate,
            workshiftsSchedulingsCopied,
            openSavePasteWorkshiftsSchedulings,
        });
    };

    const validationWorkshiftsExceptionals = () => {
        if (handlerValidateWorkshiftsExceptionals)
            handlerValidateWorkshiftsExceptionals();
    };

    const validationWorkshiftsSundaysUsuals = () => {
        if (validationUsualSundays !== 'WORKSHIFT_DATES') {
            controllerValidationWorkshiftsSundaysUsualsModal({
                grid,
                treeEmployees,
                startDate,
                endDate,
                handlerValidationWorkshiftsSundaysUsuals,
            });
        } else {
            if (saveWorkshiftsSundaysUsuals) saveWorkshiftsSundaysUsuals();
        }
    };

    const validationNovelties = () => {
        controllerInconsistenciesModal({
            grid,
            treeEmployees,
            startDate,
            endDate,
            handlerOpenInconsistenciesModal,
        });
    };

    const liquidateNovelties = async () => {
    const data: RequestLiquidatedOvertimeHourRequest = {
        employeeIds: treeEmployees.map((e) => Number(e.id)),
        endDate: `${endDate}T00:00:00`,
        startDate: `${startDate}T00:00:00`,
    };

    const toastId = toast.loading("Liquidando horas extras...");

    try {
        await overtimeLiquidation(data);
        
        toast.update(toastId, { 
            render: "Horas extras liquidadas con éxito", 
            type: "success", 
            isLoading: false,
            autoClose: 3000 
        });

        navigate(Private_Routes.MANAGE_PAYROLL_NOVELTY.index.replace(':tab', 'employee'));
    } catch (error: any) {
        toast.update(toastId, { 
            render: error.message || 'Error al liquidar Horas extras.', 
            type: "error", 
            isLoading: false,
            autoClose: 3000 
        });
    }
};

    return (
        <div id='toolsbar-actions'>
            <div className='d-flex' style={{ height: 50 }}>

                {getActionService(
                    userInfo.actions,
                     ACTIONS['remove.bonus']
                    ) && 
                        startDate && 
                        endDate && 
                        treeEmployees.length > 0 && (
                    <Link
                        className='btn btn-small btn-withe  justify-content-center align-items-center d-flex p-1'
                        title={
                            langResources['context.menu.remove.bonus']
                        }
                        to={Private_Routes.MANAGE_BONUS.index.replace(
                                ':tab',
                                'employee'
                            )}
                    >
                        <i className='ri-award-line fs-3' style={{ width: 35, height: 30 }}></i>
                    </Link>
                )}

                {getActionService(
                    userInfo.actions,
                    ACTIONS['approve-payroll-novelty-flows']
                ) &&
                    startDate &&
                    endDate &&
                    treeEmployees.length > 0 && (
                        <button
                            className='btn btn-small btn-withe justify-content-center align-items-center d-flex p-1'
                            title={'Administrar horas extras'}
                            onClick={liquidateNovelties}
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <div className="spinner-border spinner-border-sm text-primary" role="status"></div>
                            ) : (
                                <i className='ri-settings-2-fill fs-3' style={{ width: 35, height: 30 }}></i>
                            )}
                        </button>
                    )}

                {getActionService(
                    userInfo.actions,
                    ACTIONS['management.scheduling']
                ) && (
                    <button
                        className='btn btn-small btn-withe  justify-content-center align-items-center d-flex p-1'
                        title={langResources['context.menu.inconsistencies.title']}
                        onClick={validationNovelties}
                    >
                        <i
                            className=' ri-spam-3-line fs-3'
                            style={{ width: 35, height: 30 }}
                        ></i>
                    </button>
                )}

                {getActionService(
                    userInfo.actions,
                    ACTIONS['AllowValidatingTheUsualSundayWorkShiftSchedules']
                ) && (
                    <button
                        className='btn btn-small btn-withe  justify-content-center align-items-center d-flex p-1'
                        title={'Validación dominicales'}
                        onClick={validationWorkshiftsSundaysUsuals}
                    >
                        <i
                            className=' ri-settings-6-line fs-3'
                            style={{ width: 35, height: 30 }}
                        ></i>
                    </button>
                )}

                {getActionService(
                    userInfo.actions,
                    ACTIONS['validate.compensated.shifts']
                ) && (
                    <button
                        className='btn btn-small btn-withe  justify-content-center align-items-center d-flex p-1'
                        title={
                            langResources[
                                'context.menu.validate.exceptional.workshift'
                            ]
                        }
                        onClick={validationWorkshiftsExceptionals}
                    >
                        <i
                            className=' ri-list-settings-line fs-3'
                            style={{ width: 35, height: 30 }}
                        ></i>
                    </button>
                )}

                {getActionService(
                    userInfo.actions,
                    ACTIONS['create.workshift.scheduling']
                ) && (
                    <button
                        className='btn btn-small btn-withe  justify-content-center align-items-center d-flex p-1'
                        title={langResources['context.menu.add.workshift']}
                        onClick={openWorkshift}
                    >
                        <img
                            src='/assets/images/menuBar/createWorkshift.svg'
                            className='w-100 h-100'
                            style={{ width: 35, height: 30 }}
                            alt=''
                        />
                    </button>
                )}

                {getActionService(
                    userInfo.actions,
                    ACTIONS['delete.workshift.scheduling']
                ) && (
                    <button
                        className='btn btn-small btn-withe  justify-content-center align-items-center d-flex p-1'
                        title={langResources['context.menu.delete.workshift']}
                        onClick={openDeleteWorkshift}
                    >
                        <img
                            className='w-100 h-100'
                            src='/assets/images/menuBar/deleteWorkshift.svg'
                            style={{ width: 35, height: 30 }}
                            alt=''
                        />
                    </button>
                )}

                {getActionService(
                    userInfo.actions,
                    ACTIONS['create.exceptional']
                ) && (
                    <button
                        className='btn btn-small btn-withe  justify-content-center align-items-center d-flex p-1'
                        title={
                            langResources['context.menu.add.exceptional.workshift']
                        }
                        onClick={openExceptionalWorkshift}
                    >
                        <img
                            className='w-100 h-100'
                            src='/assets/images/menuBar/createExceptionalWorkshift.svg'
                            style={{ width: 35, height: 30 }}
                            alt=''
                        />
                    </button>
                )}

                {getActionService(
                    userInfo.actions,
                    ACTIONS['create.interruption']
                ) && (
                    <button
                        className='btn btn-small btn-withe  justify-content-center align-items-center d-flex p-1'
                        title={langResources['context.menu.add.interruption']}
                        onClick={openInterruption}
                    >
                        <img
                            className='w-100 h-100'
                            src='/assets/images/menuBar/createInterruptions.svg'
                            style={{ width: 35, height: 30 }}
                            alt=''
                        />
                    </button>
                )}

                {getActionService(
                    userInfo.actions,
                    ACTIONS['modify.interruption']
                ) && (
                    <button
                        className='btn btn-small btn-withe  justify-content-center align-items-center d-flex p-1'
                        title={
                            langResources['context.menu.delete.update.interruption']
                        }
                        onClick={openUpdateInterruptions}
                    >
                        <img
                            className='w-100 h-100'
                            src='/assets/images/menuBar/updateInterruptions.svg'
                            style={{ width: 35, height: 30 }}
                            alt=''
                        />
                    </button>
                )}

                {getActionService(userInfo.actions, ACTIONS['daily.attendance']) && (
                    <button
                        className='btn btn-small btn-withe  justify-content-center align-items-center d-flex p-1'
                        title={langResources['context.menu.print.interruptions']}
                        onClick={downloadInterrptionFormat}
                    >
                        <img
                            className='w-100 h-100'
                            src='/assets/images/menuBar/printInterruptions.svg'
                            style={{ width: 35, height: 30 }}
                            alt=''
                        />
                    </button>
                )}

                {getActionService(
                    userInfo.actions,
                    ACTIONS['create.additional']
                ) && (
                    <button
                        className='btn btn-small btn-withe  justify-content-center align-items-center d-flex p-1'
                        title={langResources['context.menu.add.additional.hours']}
                        onClick={openAdditionalsHours}
                    >
                        <img
                            className='w-100 h-100'
                            src='/assets/images/menuBar/createAdditional.svg'
                            style={{ width: 35, height: 30 }}
                            alt=''
                        />
                    </button>
                )}

                {getActionService(
                    userInfo.actions,
                    ACTIONS['modify.additionals']
                ) && (
                    <button
                        className='btn btn-small btn-withe  justify-content-center align-items-center d-flex p-1'
                        title={
                            langResources['context.menu.updated.additional.hours']
                        }
                        onClick={openUpdateAdditionalHours}
                    >
                        <img
                            className='w-100 h-100'
                            src='/assets/images/menuBar/updateAdditional.svg'
                            style={{ width: 35, height: 30 }}
                            alt=''
                        />
                    </button>
                )}

                {getActionService(userInfo.actions, ACTIONS['modify.news']) && (
                    <button
                        className='btn btn-small btn-withe  justify-content-center align-items-center d-flex p-1'
                        title={langResources['context.menu.add.cost.center']}
                        onClick={openCostCenter}
                    >
                        <img
                            className='w-100 h-100'
                            src='/assets/images/menuBar/assignedCostCenter.svg'
                            alt=''
                            style={{ width: 35, height: 30 }}
                        />
                    </button>
                )}

                {getActionService(userInfo.actions, ACTIONS['modify.news']) && (
                    <button
                        className='btn btn-small btn-withe  justify-content-center align-items-center d-flex p-1'
                        title={
                            langResources['disassociate.cost.center.modal']['title']
                        }
                        onClick={openDisassociatedCostCenter}
                    >
                        <img
                            className='w-100 h-100'
                            src='/assets/images/menuBar/disassociateCostCentes.svg'
                            alt=''
                            style={{ width: 35, height: 30 }}
                        />
                    </button>
                )}

                {getActionService(userInfo.actions, ACTIONS['modify.news']) && (
                    <button
                        className='btn btn-small btn-withe  justify-content-center align-items-center d-flex p-1'
                        title={langResources['context.menu.add.business.unit']}
                        onClick={openBusinessUnits}
                    >
                        <img
                            className='w-100 h-100'
                            src='/assets/images/menuBar/businessUnit.svg'
                            alt=''
                            style={{ width: 35, height: 30 }}
                        />
                    </button>
                )}

                {getActionService(userInfo.actions, ACTIONS['modify.news']) && (
                    <button
                        className='btn btn-small btn-withe  justify-content-center align-items-center d-flex p-1'
                        title={
                            langResources['disassociate.business.units.modal'][
                                'title'
                            ]
                        }
                        onClick={openDisassociatedBusinessUnits}
                    >
                        <img
                            className='w-100 h-100'
                            src='/assets/images/menuBar/disassociateBusinessUnits.svg'
                            alt=''
                            style={{ width: 35, height: 30 }}
                        />
                    </button>
                )}

                <button
                    className='btn btn-small btn-withe  justify-content-center align-items-center d-flex  p-1'
                    title={langResources['paste.programation']['copy.label']}
                    onClick={openCopyWorkshiftsScheduling}
                >
                    <img
                        src='/assets/images/menuBar/copy.svg'
                        alt=''
                        className='w-100 h-100'
                        style={{ maxHeight: 25, maxWidth: 25, width: 25 }}
                    />
                </button>

                {workshiftsSchedulingsCopied.toCopy.length > 0 && (
                    <button
                        className='btn btn-small btn-withe  justify-content-center align-items-center d-flex  p-1'
                        title={langResources['paste.programation']['paste.label']}
                        onClick={openPasteWorkshiftsScheduling}
                    >
                        <img
                            src='/assets/images/menuBar/paste.svg'
                            alt=''
                            className='w-100 h-100'
                            style={{ maxHeight: 25, maxWidth: 25, width: 25 }}
                        />
                    </button>
                )}
            </div>
        </div>
    );
};

export default ToolsBar;
